"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _I18n = _interopRequireDefault(require("I18n"));

var _default = _react.default.createClass({
  displayName: "FormattedSize",
  propTypes: {
    value: _react.PropTypes.number.isRequired
  },
  render: function render() {
    var _this$props = this.props,
        value = _this$props.value,
        options = (0, _objectWithoutProperties2.default)(_this$props, ["value"]);
    return _react.default.createElement("span", null, _I18n.default.formatSize(value, options));
  }
});

exports.default = _default;
module.exports = exports.default;